module.exports = __webpack_public_path__ + "img/blueBg.070d6737.png";